import { render, staticRenderFns } from "./deleteChainInoutOrder.vue?vue&type=template&id=bd2ee1d6"
import script from "./deleteChainInoutOrder.vue?vue&type=script&lang=js"
export * from "./deleteChainInoutOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports